import React, { useState, useEffect } from "react";
import image from "../../assets/imagebanner.png";

function CustomBanner({ data }) {
   console.log("Banner Posts", data);
   const [currentSlide, setCurrentSlide] = useState(0);
   const [nextSlide, setNextSlide] = useState(1);

   useEffect(() => {
      const interval = setInterval(() => {
         setCurrentSlide((prevSlide) => (prevSlide + 1) % data.length);
         setNextSlide((prevSlide) => (prevSlide + 1) % data.length);
      }, 10000); // Change slide every 3 seconds

      return () => clearInterval(interval);
   }, [data.length]); // Add data.length as a dependency to useEffect

   const hexToRgb = (hex) => {
      // Remove # if present
      hex = hex.replace(/^#/, "");

      // Convert to RGB
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return `${r}, ${g}, ${b}`;
   };

   const rgbaColor = (hex, alpha) => `rgba(${hexToRgb(hex)}, ${alpha})`;

   return (
      <div className="blog__blogBanner__sliderWrapper">
         {Object.entries(data)?.map(([key, value]) => {
            console.log(key, value);
            const firstParagraph = value?.content?.blocks?.find(
               (block) => block?.type === "Paragraph",
            );
            var paragraphText = "";
            if (firstParagraph) {
               // Extract the HTML content of the first paragraph
               const paragraphHTML = firstParagraph.data.text;

               // Use a regular expression to remove HTML tags and then get the first 150 characters
               paragraphText = paragraphHTML.replace(/<[^>]*>/g, "").substring(0, 150);
            }
            return (
               <div
                  key={key}
                  className={`blog__customBanner ${
                     key == currentSlide ? "active" : key == nextSlide ? "nextActive" : ""
                  }`}
               >
                  <div
                     className="text-Wrapper"
                     style={{ backgroundColor: rgbaColor(value?.featured_color, 0.09) }}
                  >
                     <div
                        style={{
                           padding: "12px",
                           // backgroundColor: "transparent",
                           borderRadius: "12px",
                           minHeight: "40%",
                           paddingLeft: "24px",
                        }}
                        className="d-flex flex-column justify-center inner-div"
                     >
                        <p className="category" style={{ color: value?.featured_color }}>
                           DishHome
                        </p>
                        <p className="heading">{value?.title}</p>
                        <p className="text" style={{ backgroundColor: "transparent" }}>
                           {paragraphText}...
                        </p>
                     </div>
                  </div>
                  <div className="image">
                     <img
                        src={`${process.env.REACT_APP_FILE_URL}/${value?.featured_image}`}
                        alt=""
                     />
                  </div>
               </div>
            );
         })}
         <div className="blogbanner__pagination">
            {Object.entries(data)?.map(([key, value]) => {
               return (
                  <div
                     className={`paginationComponent ${currentSlide == key ? "active" : ""}`}
                     onClick={() => {
                        setCurrentSlide(key);
                        setNextSlide((key + 1) % data.length);
                     }}
                  ></div>
               );
            })}
         </div>
      </div>
   );
}

export default CustomBanner;
